import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  pulse?: boolean;
  className?: string;
};
export function CtaButton({
  children,
  onClick,
  pulse = true,
  className = ''
}: CtaButtonProps) {
  return <button type="button" onClick={onClick} className={`w-full min-h-[56px] rounded-[14px] px-5 py-4 font-sans text-[18px] font-bold text-white
        bg-gold
        shadow-[0_8px_24px_rgba(62,107,59,0.28)]
        touch-manipulation select-none transition-transform duration-100 active:scale-[0.97]
        focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-night
        ${pulse ? 'animate-cta-pulse' : ''} ${className}`} data-id="element-45" data-mp="hlgofrp3ezm5">
      {children}
    </button>;
}